import React, { useRef, useState } from 'react';
import { Fieldset } from 'primereact/fieldset';
import { Growl } from 'primereact/growl';
import { useHistory } from 'react-router-dom';
import UploadArquivos from '../uploadArquivos/index.jsx';
import { Button } from 'primereact/button';
import { retornoHashValor } from '../../modulos/cripotografia/hash.js';

const url = retornoHashValor(process.env.REACT_APP_1);

const formatoArquivosAceitos = '.jpeg,.jpg,.png';
const tamanhoMaximoArquivo = 10000 * Math.pow(10, 3); // 10MB

const UploadContratoContaDeLuz = ({ inscricao }) => {
    const [totalArquivosUpados, setTotalArquivosUpados] = useState(0);
    const [autorizacao, setAutorizacao] = useState(false);
    const history = useHistory();
    const mensagemUpload = useRef(null);
    const mostrarMensagemUpload = () => {
        mensagemUpload.current.show({
            severity: 'success',
            summary: 'Arquivo enviado com sucesso!',
            detail: '',
            life: 8000
        });
    };

    const mostrarMensagemUploadErro = () => {
        mensagemUpload.current.show({
            severity: 'error',
            summary: 'Ops! Erro ao enviar arquivo!',
            detail: 'Tente novamente.',
            life: 8000
        });
    };

    const styles = {
        main: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '20px 0'
        },
        tooltip: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end'
        }
    };

    const onUploadAutorizacao = () => {
        mostrarMensagemUpload();
        setAutorizacao(true);
        setTotalArquivosUpados(state => state + 1);
    };

    const irParaProximaEtapa = () => {
        setTimeout(() => {
            history.push(`/cadastrar-dependentes/${inscricao}`);
        }, 1000);
    };

    return (
        <Fieldset legend="Upload de Arquivos">
            <Growl ref={mensagemUpload} />
            <div style={styles.tooltip}>
                <Button
                    className="p-button-raised"
                    icon="pi pi-question"
                    tooltip="Selecione uma imagem do tipo .png, .jpg ou .jpeg e depois clique em upload. Depois de fazer o upload de todos os arquivos o botão para ir para a próxima etapa será habilitado."
                />
            </div>
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-12">
                    <div className="card">
                        <div className="comprovantes">
                            <div className="primeiro">
                                <p className="p_comprovantes">
                                    Autorização para débito na fatura de energia
                                    elétrica
                                </p>
                                <UploadArquivos
                                    label="Selecione"
                                    formato={formatoArquivosAceitos}
                                    modo="advanced"
                                    tamanhoMaximoArquivo={tamanhoMaximoArquivo}
                                    url={`${url}/file-doc/${inscricao}/ACCL`}
                                    onUpload={onUploadAutorizacao}
                                    onError={mostrarMensagemUploadErro}
                                    disabled={autorizacao}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={styles.main}>
                <Button
                    label="Cadastrar Dependentes"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    disabled={totalArquivosUpados === 1 ? false : true}
                    onClick={irParaProximaEtapa}
                />
            </div>
        </Fieldset>
    );
};

export default UploadContratoContaDeLuz;
